<template>
  <footer class="section footer footer-styles">
    <div class="container">
      <div class="content-wrapper">
        <div class="columns">
          <!-- Navigation columns -->
          <nav
            v-for="column in menuColumns"
            :key="column.title"
            :aria-label="column.title"
            class="column"
          >
            <h2 class="has-text-weight-bold py-4 footer-headings">
              {{ column.title }}
            </h2>

            <ul>
              <li v-for="link in column.links" :key="link.href" class="pb-3">
                <a :href="link.href" @click="track('menu', link.label)">
                  {{ link.label }}
                </a>
              </li>
            </ul>
          </nav>

          <!-- Contact column -->
          <div class="column">
            <h2 class="has-text-weight-bold py-4 footer-headings">
              {{ contactInfo.title }}
            </h2>
            <address>
              <span
                v-for="(line, index) in contactInfo.addressLines"
                :key="index"
              >
                {{ line
                }}<br v-if="index < contactInfo.addressLines.length - 1" />
              </span>
            </address>
          </div>
        </div>

        <!-- Bottom section -->
        <div class="columns is-align-items-flex-end footer-bottom">
          <!-- Logo -->
          <div :class="{ 'p-3': $mq === 'mobile' }">
            <a href="https://cazana.com" aria-label="Cazana Home">
              <img
                :src="require('core/img/logos/cazana-logo-white.png')"
                alt="Cazana"
                loading="lazy"
                style="max-width: 120px; height: auto"
              />
            </a>
          </div>

          <!-- Legal Links -->
          <nav aria-label="Legal" class="column">
            <ul class="columns is-justify-content-center">
              <li
                v-for="link in legalLinks"
                :key="link.href"
                :class="[$mq === 'mobile' ? 'column' : 'pr-4']"
              >
                <a
                  :href="link.href"
                  :target="link.target"
                  :rel="link.rel"
                  @click="track('legal', link.label)"
                >
                  {{ link.label }}
                </a>
              </li>
            </ul>
          </nav>

          <!-- Social Links -->
          <nav aria-label="Social Media" :class="{ 'p-3': $mq === 'mobile' }">
            <h2 class="has-text-weight-bold py-4 footer-headings">Follow us</h2>
            <ul class="columns">
              <li
                class="column"
                v-for="social in socialLinks"
                :key="social.name"
              >
                <a
                  :href="social.href"
                  :aria-label="`Follow us on ${social.name}`"
                  @click="track('social', social.name)"
                >
                  <i :class="social.iconClass" aria-hidden="true" />
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { menuColumns, legalLinks, socialLinks, contactInfo } from './config'

export default {
  name: 'AppFooter',
  computed: {
    currentYear: () => new Date().getFullYear()
  },
  data() {
    return {
      menuColumns,
      legalLinks,
      socialLinks,
      contactInfo
    }
  },
  methods: {
    track(linkType, linkName) {
      const link = linkName.toLowerCase().split(' ').join('_')
      this.$mxp.track(`app_footer_${linkType}_${link}`)
    }
  }
}
</script>
